import { render, staticRenderFns } from "./EntityItemTypeOfResponse.vue?vue&type=template&id=efcb0c90&"
import script from "./EntityItemTypeOfResponse.vue?vue&type=script&lang=ts&"
export * from "./EntityItemTypeOfResponse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports